import { createContext } from 'react';

export default createContext({
  isWrong: false,
  setIsWrong: (value: boolean) => {}
});